import { Fab, Tooltip } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import Slider from '@material-ui/core/Slider'
import EurestoForm from 'Components/Form'
import Input from 'Components/Input'
import Modal from 'Components/Modal'
import Select from 'Components/Select'
import Switch from 'Components/Switch'
import Title from 'Components/Title'
import Traduction from 'Components/Traduction'
import ApiRequest from 'EurestoApi/ApiRequest'
import User from 'EurestoClass/User'
import Constants from 'EurestoFonction/Constants'
import Utils from 'EurestoFonction/Utils'
import React from 'react'
import DataComponent from '../../../DataComponents/index'
import EurestoDiv from '../../../EurestoDiv/index'

const project = require('EurestoConfig/project.config')

export default class extends React.Component {
  constructor(props) {
    super(props)
    const newState = {
      ...props,
      action: props.action,
      key: Utils.getRandomNumber()
    }
    this.state = {
      saveState: { ...EurestoClone(newState) },
      ...newState
    }
  }

  componentDidMount() {
    if (this.state.action === 'update' || this.state.action === 'duplicate' || this.state.action === 'view') {
      this.getProduit()
    }
  }

  getProduit = async () => {
    const result = await ApiRequest(project.api + 'restaurant', {
      requete: 'produit',
      action: 'get',
      id: this.state.id
    }, { showAlertError: false })
    if (result && result.code === 1) {
      const newState = {
        defaultLibelle: result.results.libelle && result.results.libelle.length > 0 && result.results.libelle[0].text,
        libelle: result.results.libelle,
        adresses_mail_retour: result.results.adresses_mail_retour,
        message_fin_resa_demande: result.results.message_fin_resa_demande,
        message_fin_resa_confirmation: result.results.message_fin_resa_confirmation,
        commentaire_actif: result.results.commentaire_actif,
        actif: result.results.actif,
        carcasses: result.results.carcasses,
        reservation_couverts_max: result.results.reservation_couverts_max,
        quantite_couverts_max: result.results.quantite_couverts_max,
        gst_couverts: result.results.gestion_limite_couverts === 1 || result.results.gestion_limite_couverts === 2,
        demande_accept: result.results.gestion_limite_couverts === 2,
        limite_couverts_confirmation: result.results.limite_couverts_confirmation,
        key: Utils.getRandomNumber()
      }
      this.setState({
        saveState: { action: 'view', ...EurestoClone(this.state.saveState), ...EurestoClone(newState) },
        ...newState,
        key: Utils.getRandomNumber()
      }, this.forceUpdate)
    }
  }

  onChangeState = (e, name) => {
    this.setState({
      [name]: e
    }, this.forceUpdate)
  }

  onCancel = () => {
    this.setState({
      libelle: undefined,
      adresses_mail_retour: undefined,
      gst_couverts: false,
      demande_accept: false,
      message_fin_resa_demande: undefined,
      message_fin_resa_confirmation: undefined,
      carcasses: [],
      commentaire_actif: undefined,
      actif: 1,
      reservation_couverts_max: undefined,
      quantite_couverts_max: undefined,
      limite_couverts_confirmation: undefined,
      key: Utils.getRandomNumber(),
      action: 'add',
    }, () => this.props.onCancel())
  }

  onSave = async (action) => {//test
    const result = await ApiRequest(project.api + 'restaurant', {
      requete: 'produit',
      action: action === 'update' ? 'update' : 'add',
      id: this.state.id,
      libelle: this.state.libelle,
      adresses_mail_retour: this.state.adresses_mail_retour,
      gestion_limite_couverts: this.state.demande_accept && 2 || this.state.gst_couverts && 1 || 0,
      message_fin_resa_demande: this.state.message_fin_resa_demande,
      message_fin_resa_confirmation: this.state.message_fin_resa_confirmation,
      commentaire_actif: this.state.commentaire_actif,
      actif: this.state.actif,
      carcasses: this.state.carcasses,
      reservation_couverts_max: this.state.reservation_couverts_max,
      quantite_couverts_max: this.state.quantite_couverts_max,
      limite_couverts_confirmation: this.state.limite_couverts_confirmation,
    })
    if (result.code === 1) {
      this.onCancel()
    }
  }

  onDelete = async () => {
    const r = await ApiRequest(project.api + 'restaurant', {
      requete: 'produit',
      action: 'delete',
      id: this.state.id,
    })
    if (r && r.code === 1) {
      this.setState({
        action: this.props.isAllow && (this.props.isAllow.add && 'add' || ' ')
      })
    }
  }

  onArchive = async () => {
    console.log('not done yet')
  }

  onView = (action) => {
    const newState = this.state.saveState
    newState.saveState = { ...EurestoClone(this.state.saveState) }
    newState.key = Utils.getRandomNumber()
    const keys = Object.keys(this.state)
    const stateReset = keys.reduce((acc, v) => ({ ...acc, [v]: undefined }), {})
    this.setState({
      ...stateReset,
      ...newState
    }, action === 'add' && this.props.onCancel(false) || this.forceUpdate)
  }

  valuetext = (value) => {
    return `${value}`
  }

  form = (disabled, autoFocus) => {
    return (
      <Grid key={this.state.key} container style={{ margin: 0, padding: 0 }} spacing={0} direction="column"
        justify="flex-start"
        alignItems="stretch">
        <Traduction
          key={autoFocus}
          autoFocus={autoFocus}
          title={EurestoI18n.t('commun:Nom')}
          disabled={disabled}
          onChange={this.onChangeState}
          name={'libelle'}
          data={this.state.libelle !== undefined ? this.state.libelle : []}
          type={Constants.typeSaisie.SaisieLibre}
        />
        <Input
          title={EurestoI18n.t('commun:Emails notifiables')}
          disabled={disabled}
          onChange={this.onChangeState}
          name={'adresses_mail_retour'}
          value={this.state.adresses_mail_retour !== undefined ? this.state.adresses_mail_retour : ''}
          type={'text'}
        />
        <Input
          title={EurestoI18n.t('commun:Nombre de couverts maximum par service')}
          disabled={disabled}
          onChange={this.onChangeState}
          name={'quantite_couverts_max'}
          value={this.state.quantite_couverts_max !== undefined ? this.state.quantite_couverts_max : ''}
          type={'number'}
        />
        <Input
          title={EurestoI18n.t('commun:Nombre de couverts maximum par réservation')}
          disabled={disabled}
          onChange={this.onChangeState}
          name={'reservation_couverts_max'}
          value={this.state.reservation_couverts_max !== undefined ? this.state.reservation_couverts_max : ''}
          type={'number'}
        />
        <Switch
          label={EurestoI18n.t('commun:Complet si nombre de couverts maxi atteint')}
          name="gst_couverts"
          key={'gst_couverts' + '-' + this.state.gst_couverts}
          disabled={disabled}
          checked={this.state.gst_couverts}
          onChange={this.onChangeState} />
        {this.state.gst_couverts && <Switch
          label={EurestoI18n.t('commun:Réservations web automatiquement confirmées')}
          name="demande_accept"
          disabled={disabled}
          key={'demande_accept' + '-' + this.state.demande_accept}
          checked={this.state.demande_accept}
          onChange={this.onChangeState} />}
        {
          this.state.demande_accept && this.state.reservation_couverts_max &&
          <Title title={EurestoI18n.t('commun:Réservation passée en demande si nombre de couverts supérieure à')}>
            <Slider
              disabled={disabled}
              style={{ marginTop: 10 }}
              step={1}
              min={1}
              max={this.state.reservation_couverts_max}
              valueLabelDisplay="on"
              value={this.state.limite_couverts_confirmation}
              onChange={(e, value) => this.onChangeState(value, 'limite_couverts_confirmation')} />
          </Title>
        }
        <Select
          title={EurestoI18n.t('commun:Réservable depuis l\'espace web ?')}
          name="actif"
          disabled={disabled}
          options={[
            {
              label: EurestoI18n.t('commun:Oui'),
              value: 1
            },
            {
              label: EurestoI18n.t('commun:Non'),
              value: 0
            }
          ]}
          value={this.state.actif !== undefined ? this.state.actif : 1} onChange={this.onChangeState} />
        <DataComponent
          title={EurestoI18n.t('crm:Carcasses')}
          name="carcasses"
          disabled={disabled}
          type={Constants.typeSaisie.ComboMulti}
          onChange={this.onChangeState}
          data={this.state.carcasses}
          object={Constants.donnee.carcasse}
          module={Constants.module.RESTAURANT}
        />
        <Grid container>
          <Grid item xs>
            Message de fin de prise d'une réservation web (demande) :
          </Grid>
          <Grid item>
            <Tooltip disableTouchListener style={{ zIndex: 1 }} placement="bottom"
              title={<div
                style={{
                  fontSize: 15,
                  padding: 5,
                  paddingLeft: 10,
                  paddingRight: 10,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: '-moz-pre-wrap',
                  //wordBreak: 'break-all',
                  overflowWrap: 'break-word',
                  textAlign: 'left',
                  //lineHeight: '15px',
                }} dangerouslySetInnerHTML={{
                  __html: this.state.message_fin_resa_demande !== undefined
                    && this.state.message_fin_resa_demande[0]
                    && this.state.message_fin_resa_demande[0].text || 'Non renseigné'
                }} />}>
              <Fab size="small"
                onClick={() => !disabled && this.setState({
                  finResaModal: 'demande'
                })}
                style={{
                  cursor: disabled && 'not-allowed' || 'pointer'
                }}
                className={'pull pull-right EurestoPrimary'}>
                <i className={'ei-commun_modifier EurestoSecondary--text'} /></Fab>
            </Tooltip>
          </Grid>
        </Grid>
        {this.state.demande_accept && this.state.reservation_couverts_max &&
          <Grid container>
            <Grid item xs>Message de fin de prise d'une réservation web (confirmation auto)
          </Grid>
            <Grid item>
              <Tooltip disableTouchListener style={{ zIndex: 1 }} placement="bottom"
                title={<div
                  style={{
                    fontSize: 15,
                    padding: 5,
                    paddingLeft: 10,
                    paddingRight: 10,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: '-moz-pre-wrap',
                    //wordBreak: 'break-all',
                    overflowWrap: 'break-word',
                    textAlign: 'left',
                    //lineHeight: '15px',
                  }} dangerouslySetInnerHTML={{
                    __html: this.state.message_fin_resa_confirmation !== undefined
                      && this.state.message_fin_resa_confirmation[0]
                      && this.state.message_fin_resa_confirmation[0].text || 'Non renseigné'
                  }} />}>
                <div>
                  <Fab size="small"
                    style={{
                      cursor: disabled && 'not-allowed' || 'pointer'
                    }}
                    onClick={() => !disabled && this.setState({
                      finResaModal: 'confirmation'
                    })}
                    className={'pull pull-right EurestoPrimary'}>
                    <i className={'ei-commun_modifier EurestoSecondary--text'} /></Fab>
                </div>
              </Tooltip>
            </Grid>
          </Grid>
        }
      </Grid>
    )
  }

  render() {
    return (
      <Grid container>
        <EurestoForm key={this.state.key}
          {...this.props.formProps}
          libelle={this.state.defaultLibelle}
          action={this.state.action}
          isAllow={this.props.isAllow}
          onSave={this.onSave}
          onCancel={this.onCancel}
          onDelete={this.onDelete}
          onArchive={this.onArchive}
          onView={this.onView}
          libelleAdd={EurestoI18n.t('commun:Nouveau restaurant')}
          children={this.form} />
        <Modal key={this.state.finResaModal} open={this.state.finResaModal} onClose={() => this.setState({
          finResaModal: false
        })}>
          <EurestoDiv title={'Message fin réservation [' + this.state.defaultLibelle + ']'} buttonsRight={[{
            icon: ' ei-commun_fermer',
            className: 'EurestoText EurestoError--text',
            cb: () => this.setState({
              finResaModal: false
            })
          }]}>
            <Traduction
              autoFocus={true}
              height={User.CalculHeight.getHeightWanted(200)}
              onChange={this.onChangeState}
              name={'message_fin_resa_' + this.state.finResaModal}
              data={this.state['message_fin_resa_' + this.state.finResaModal] !== undefined ? this.state['message_fin_resa_' + this.state.finResaModal] : []}
              type={Constants.typeSaisie.Wysiwyg}
            />
          </EurestoDiv>
        </Modal>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataForm/Template/Reservation/Produit.js